'use client';

import { type FC } from 'react';
import { FirmRolePills, Flex } from '@/_components';
import type { FirmRoleSettingsProps } from './FirmRoleSettingsForm.types';

export const FirmRoleSettingsForm: FC<FirmRoleSettingsProps> = ({
  company,
}) => {
  return (
    <Flex isColumn={true} gap={4}>
      <FirmRolePills isEditing={true} company={company} />
    </Flex>
  );
};
